import { DefaultLayout } from '@fondationcss/ui'
import PageWrapper from '@/page-wrapper.vue'

export const getCustomRoutes = () => [
  {
    path: '/',
    component: DefaultLayout,
    meta: { title: 'Heuriqa', hideFooter: true },
    children: [
      {
        // Renders <PageHeader> (breadcrumbs) above every routed page.
        path: '',
        component: PageWrapper,
        children: [
          { path: '', redirect: '/boards' },

          // ── Boards ────────────────────────────────────────────
          {
            name: 'boards',
            path: 'boards',
            component: () => import('@/views/boards/board-list.vue'),
            meta: { title: 'Tableaux', hideFooter: true },
          },
          {
            name: 'board-detail',
            path: 'boards/:slug',
            component: () => import('@/views/boards/board-detail.vue'),
            meta: { title: 'Tableau', hideFooter: true },
          },

          // ── Posts ─────────────────────────────────────────────
          {
            name: 'post-detail',
            path: 'boards/:slug/posts/:id',
            component: () => import('@/views/posts/post-detail.vue'),
            meta: { title: 'Idée', hideFooter: true },
          },

          // ── Roadmap ───────────────────────────────────────────
          {
            name: 'roadmap',
            path: 'roadmap',
            component: () => import('@/views/roadmap/roadmap.vue'),
            meta: { title: 'Feuille de route', hideFooter: true },
          },

          // ── Admin ─────────────────────────────────────────────
          {
            name: 'admin-dashboard',
            path: 'admin',
            component: () => import('@/views/admin/dashboard.vue'),
            meta: { title: 'Administration', hideFooter: true },
          },
          {
            name: 'admin-board-settings',
            path: 'admin/boards/:id',
            component: () => import('@/views/admin/board-settings.vue'),
            meta: { title: 'Paramètres du tableau', hideFooter: true },
          },
          {
            name: 'admin-users',
            path: 'admin/users',
            component: () => import('@/views/admin/users.vue'),
            meta: { title: 'Gestion des utilisateurs', hideFooter: true },
          },
        ],
      },
    ],
  },
]
